module.exports = __webpack_public_path__ + "static/img/08.4dc1adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/08.png
// module id = nA6Q
// module chunks = 1